  import React, { useState, useEffect, useRef } from 'react';

  const FunFactsSection = () => {
    const [countersVisible, setCountersVisible] = useState([false, false, false]);
    const sectionRef = useRef(null);
    
    const funFacts = [
      { 
        icon: "/assets/images/service/01.svg", 
        count: 1200, 
        text: "Over 1,000 projects successfully delivered, from residential homes to large developments...",
        suffix: "+"
      },
      { 
        icon: "/assets/images/service/02.svg", 
        count: 85, 
        text: "85% of clients return for future projects, demonstrating our commitment to quality...",
        suffix: "%"
      },
      { 
        icon: "/assets/images/service/03.svg", 
        count: 20, 
        text: "Consistent 20% annual revenue growth over the past five years, reflecting our expanding...",
        suffix: "%"
      }
    ];

    // Set up Intersection Observer to trigger animation when section is in view
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setCountersVisible([true, true, true]);
          }
        },
        { threshold: 0.3 }
      );

      if (sectionRef.current) {
        observer.observe(sectionRef.current);
      }

      return () => {
        if (sectionRef.current) {
          observer.unobserve(sectionRef.current);
        }
      };
    }, []);

    return (
      <div ref={sectionRef} className="py-5 bg-gradient-to-br from-blue-50 to-indigo-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#063970] mb-2">Our Achievements</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Numbers that showcase our dedication and success in the construction industry
            </p>
          </div>
          
          <div className="flex flex-wrap -mx-4">
            {funFacts.map((fact, index) => (
              <div key={index} className="w-full md:w-1/3 px-4 mb-4">
                <div className="bg-white p-5 rounded-xl shadow-sm hover:shadow-xl transition-all duration-500 h-full transform hover:-translate-y-2 group border border-[#063970]/10">
                  <div className="icon mb-1 flex justify-center">
                    <div className="relative">
                      <div className="absolute -inset-4 bg-[#063970]/10 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                      <div className="relative p-4 rounded-full group-hover:scale-110 transition-transform duration-500">
                        <img 
                          src={fact.icon} 
                          alt="service" 
                          className="h-12 w-12" 
                        />
                      </div>
                    </div>
                  </div>
                  
                  <h2 className="text-4xl font-bold mb-2 text-center text-[#063970]">
                    <Counter 
                      value={fact.count} 
                      isVisible={countersVisible[index]} 
                      duration={2000} 
                    />
                    {fact.suffix}
                  </h2>
                  
                  <p className="text-gray-600 text-center leading-relaxed mt-4">
                    {fact.text}
                  </p>
                  
                  <div className="mt-6 flex justify-center">
                    <div className="h-1 w-16 bg-[#063970] rounded-full transform group-hover:scale-x-150 transition-transform duration-500"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  // Counter component with animation
  const Counter = ({ value, isVisible, duration = 2000 }) => {
    const [count, setCount] = useState(0);
    const [hasAnimated, setHasAnimated] = useState(false);

    useEffect(() => {
      if (isVisible && !hasAnimated) {
        setHasAnimated(true);
        
        let startTime = null;
        const animateCount = (timestamp) => {
          if (!startTime) startTime = timestamp;
          const progress = Math.min((timestamp - startTime) / duration, 1);
          
          // Easing function for smooth animation
          const easeOutQuart = 1 - Math.pow(1 - progress, 4);
          const currentCount = Math.floor(easeOutQuart * value);
          
          setCount(currentCount);
          
          if (progress < 1) {
            requestAnimationFrame(animateCount);
          }
        };
        
        requestAnimationFrame(animateCount);
      }
    }, [isVisible, value, duration, hasAnimated]);

    return <span>{count}</span>;
  };

  export default FunFactsSection;